import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'droppings', sv, true, true)
i18n.addResourceBundle('en', 'droppings', en, true, true)

export function buildDroppingsRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/droppings',
      component: lazyRouteComponent(
        () => import('./DroppingsListPage'),
        'DroppingsListPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/droppings/$inventoryId',
      component: lazyRouteComponent(
        () => import('./DroppingDetailPage'),
        'DroppingDetailPage',
      ),
    }),
  ]
}
